<template>
  <div class="app-container">
    <list ref="list">
    </list>
    <!-- <edit-dialog ref="editDialog"></edit-dialog> -->
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from '@/components/business/stock/batchwarn/list'


export default {
  name: "currentstock",
  mixins: [curdMixins],
  components: {
    list,
  },
  data(){
    return {
    }
  },
  
};
</script>